import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  SelectChangeEvent,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import backArrow from "../../assets/icons/backArrow.svg";
import dobIcon from "../../assets/icons/dobIcon.svg";
import personalDataIcon from "../../assets/icons/personalDataIcon.svg";
import CustomLoader from "../../global/components/CustomLoader/CustomLoader";
import CustomLoader1 from "../../global/components/CustomLoader/CustomLoader1";
import CustomSelect from "../../global/components/CustomSelect/CustomSelect";
import strings from "../../global/constants/StringConstants";
import urls from "../../global/constants/UrlConstants";
import { handleErrorMessage } from "../../helpers/methods";
import {
  selectFirstName,
  selectProfileId,
  setProfileDetails,
} from "../../redux/authSlice";
import history from "../../utils/history";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";
import { theme } from "../../utils/styles";
import { formData } from "../Calculator/CalculatorData";
import { getProfileById } from "../Profile/ProfileService";
import PremiumFeatureWrapper from "../Shared/PremiumFeature/PremiumFeatureWrapper";
import analysisStyles from "./Analysis.styles";
import AnalysisCards from "./Components/Analysis/AnalysisCards";
import AnalysisLegends from "./Components/Analysis/AnalysisLegends";
import RaysLegends from "./Components/Analysis/RaysLegend";
import ArudhaPada from "./Components/ArudhaPada/ArudhaPada";
import Aspects from "./Components/Aspects/Aspects";
import CircularBirthChart from "./Components/CircularBirthChart/CircularBirthChart";
import CurrentNakshatra from "./Components/CurrentNakshatra/CurrentNakshatra";
import Football from "./Components/Football/Football";
import FootballLegend from "./Components/Football/FootballLegend";
import Houses from "./Components/Houses/Houses";
import KarmicResourcesCustom from "./Components/KarmicResources/KarmicResourcesCustom";
import Mahadasha from "./Components/Mahadasha/Mahadasha";
import MahadashaDetails from "./Components/Mahadasha/MahadashaDetails";
import SingleDashaComponent from "./Components/Mahadasha/SingleDashaComponent";
import MineralsCards from "./Components/Minerals/MineralsCards";
import MineralsLegends from "./Components/Minerals/MineralsLegends";
import Nakshatra from "./Components/Nakshatra/Nakshatra";
import Planets from "./Components/Planets/Planets";
import RahuTransits from "./Components/RahuTransits/RahuTransits";
import Data from "./Components/Report/Data";
import Shadbala from "./Components/Shadbala/Shadbala";

interface CustomProps {
  location?: any;
  selectedLanguage: string;
}

const Analysis = (props: CustomProps) => {
  const classes = analysisStyles;
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const profileId = useAppSelector(selectProfileId);
  const name = useAppSelector(selectFirstName);
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [displayVideo, setDisplayVideo] = useState<boolean>(false);
  const [goldenFoot, setGoldenFoot] = useState<boolean>(false);
  const location = props.location?.pathname?.split("/")[1].toLowerCase();
  const [selectedSubTab, setSelectedSubTab] = useState<string>(strings.DATA);
  const [selectedLegend, setSelectedLegend] = useState<string>("");
  const [selectedHouse, setSelectedHouse] = useState<string>("d1");
  const [formFields, setFormFields] = useState(formData);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const houseMenu = [
    {
      value: "d1",
      content: "D1",
    },
    {
      value: "d2",
      content: "D2",
    },
    {
      value: "d3",
      content: "D3",
    },
    {
      value: "d4",
      content: "D4",
    },
    {
      value: "d7",
      content: "D7",
    },
    {
      value: "d9",
      content: "D9",
    },
    {
      value: "d10",
      content: "D10",
    },
    {
      value: "d12",
      content: "D12",
    },
    {
      value: "d16",
      content: "D16",
    },
    {
      value: "d20",
      content: "D20",
    },
    {
      value: "d24",
      content: "D24",
    },
    {
      value: "d27",
      content: "D27",
    },
    {
      value: "d30",
      content: "D30",
    },
    {
      value: "d40",
      content: "D40",
    },
    {
      value: "d45",
      content: "D45",
    },
    {
      value: "d60",
      content: "D60",
    },
  ];

  useEffect(() => {
    profileId && getProfileDetails();
  }, []);

  useEffect(() => {
    setSelectedSubTab(strings.DATA);
  }, [location]);

  const getProfileDetails = async () => {
    try {
      setIsLoading(true);
      const response = await getProfileById(profileId!);
      setFormFields({
        firstName: {
          value: response.firstName,
          error: "",
        },
        lastName: {
          value: response.lastName,
          error: "",
        },
        bloodGroup: {
          value: response.bloodGroup,
          error: "",
        },
        sex: {
          value: response.sex,
          error: "",
        },
        birthDate: {
          value: response.birthDate,
          error: "",
        },
        birthTime: {
          value: response.birthTime,
          error: "",
        },
        birthPlace: {
          value: response.birthPlace,
          error: "",
        },
        pregnancy: {
          value: response.pregnancy,
          error: "",
        },
      });
      dispatch(
        setProfileDetails({
          profile: {
            profileId: response.profileId,
            firstName: response.firstName,
            lastName: response.lastName,
            latitude: response.latitude,
            longitude: response.longitude,
          },
        }),
      );
      setIsLoading(false);
    } catch (error: any) {
      setIsLoading(false);
      handleErrorMessage(error);
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleHouseChange = (event: SelectChangeEvent<string>) => {
    setSelectedHouse(event.target.value);
  };

  const getMenu = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        PaperProps={{
          elevation: 0,
          sx: classes.menuWrapper,
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            setSelectedLegend(strings.PLANET);
            setSelectedSubTab("Legends");
          }}
        >
          <Typography sx={classes.menuItem}>{t("planetLegend")}</Typography>
        </MenuItem>
        <MenuItem
          onClick={() => {
            setSelectedLegend(strings.RAYS);
            setSelectedSubTab("Legends");
          }}
        >
          <Typography sx={classes.menuItem}>{t("raysLegend")}</Typography>
        </MenuItem>
      </Menu>
    );
  };

  const getProfileData = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        px={{ sm: 5, xs: 5 }}
        pb={{ sm: 1, xs: 0 }}
        pt={1}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          sx={{ cursor: "pointer", width: "fit-content" }}
          onClick={() => history.push(urls.dashboardViewPath)}
        >
          {isMobile ? (
            <img src={backArrow} height={"20px"} alt="Module not found..." />
          ) : (
            <img src={backArrow} height={"25px"} alt="Module not found..." />
          )}
        </Box>
        <Grid
          container
          justifyContent={{ xl: "center", sm: "flex-start", xs: "center" }}
        >
          <Grid
            item
            px={{ sm: 4, xs: 2 }}
            py={{ sm: 0.5, xs: 0 }}
            pt={{ sm: 0, xs: 1 }}
          >
            <Stack
              direction={{ sm: "row", xs: "column" }}
              spacing={{ sm: 1, xs: 0 }}
              alignItems={"center"}
            >
              {!isTablet && (
                <img
                  src={personalDataIcon}
                  height={"35px"}
                  alt="Module Not Found..."
                />
              )}
              <Typography
                sx={{ ...classes.cardLabel, textDecoration: "underline" }}
              >
                {t("Name")}:
              </Typography>
              <Typography sx={classes.cardText}>
                {formFields?.firstName.value}
              </Typography>
              {!isTablet && (
                <img src={dobIcon} height={"35px"} alt="Module Not Found..." />
              )}
              <Typography
                sx={{ ...classes.cardLabel, textDecoration: "underline" }}
              >
                {t("birthDetails")}:
              </Typography>
              <Typography sx={classes.cardText}>
                {formFields?.birthDate?.value} - {formFields?.birthTime?.value}{" "}
                - {formFields?.birthPlace?.value}
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const componentMap = {
    [strings.REPORT]: {
      [strings.DATA]: (props: any) => (
        <Data
          formFields={props.formFields}
          setIsLoading={props.setIsLoading}
          fileName={name}
          subTabValue={strings.DATA}
        />
      ),
      [strings.COMMON_REPORT]: (props: any) => (
        <Data
          formFields={props.formFields}
          setIsLoading={props.setIsLoading}
          fileName={name}
          subTabValue={strings.COMMON_REPORT}
        />
      ),
    },
    [strings.ANALYSIS_TAB]: {
      [strings.DATA]: (props: any) => (
        <AnalysisCards
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      [strings.LEGENDS]: (props: any) =>
        props.selectedLegend === strings.PLANET ? (
          <AnalysisLegends />
        ) : (
          <RaysLegends />
        ),
    },
    [strings.MINERALS_TAB]: {
      [strings.DATA]: (props: any) => (
        <MineralsCards
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      [strings.LEGENDS]: () => <MineralsLegends />,
    },
    [strings.MAHADASHA_TAB]: {
      [strings.DATA]: (props: any) => (
        <Mahadasha
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      [strings.GOOD_TIME]: (props: any) => (
        <SingleDashaComponent
          subTabValue={strings.GOOD_TIME}
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      [strings.BAD_TIME]: (props: any) => (
        <SingleDashaComponent
          subTabValue={strings.BAD_TIME}
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      [strings.CHANGES_IN_ONE_YEAR]: (props: any) => (
        <SingleDashaComponent
          subTabValue={strings.CHANGES_IN_ONE_YEAR}
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      [strings.CHANGES_IN_LIFE_SPAN]: (props: any) => (
        <PremiumFeatureWrapper
          setIsLoading={props.setIsLoading}
          component={
            <SingleDashaComponent
              subTabValue={strings.CHANGES_IN_LIFE_SPAN}
              profileId={props.profileId}
              setIsLoading={props.setIsLoading}
            />
          }
        />
      ),
      [strings.LEGENDS]: () => <MahadashaDetails />,
    },
    [strings.PLANET_TAB]: {
      [strings.DATA]: (props: any) => (
        <Planets
          profileId={props.profileId}
          house={props.selectedHouse}
          setIsLoading={props.setIsLoading}
        />
      ),
    },
    [strings.HOUSES_TAB]: {
      [strings.DATA]: (props: any) => (
        <PremiumFeatureWrapper
          setIsLoading={props.setIsLoading}
          component={
            <Houses
              profileId={props.profileId}
              house={props.selectedHouse}
              setIsLoading={props.setIsLoading}
            />
          }
        />
      ),
    },
    [strings.FOOTBALL_TAB]: {
      [strings.DATA]: (props: any) => (
        <Football
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
          setDisplayVideo={props.setDisplayVideo}
          setGoldenFoot={props.setGoldenFoot}
        />
      ),
      [strings.LEGENDS]: () => <FootballLegend />,
    },
    [strings.NAKSHATRA_TAB]: {
      [strings.DATA]: (props: any) => (
        <Nakshatra
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
    },
    [strings.CIRCULAR_CHARTS_TAB]: {
      [strings.DATA]: (props: any) => (
        <CircularBirthChart
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
    },
    [strings.CURRENT_NAKSHATRA]: {
      [strings.DATA]: (props: any) => (
        <PremiumFeatureWrapper
          setIsLoading={props.setIsLoading}
          component={
            <CurrentNakshatra
              profileId={props.profileId}
              setIsLoading={props.setIsLoading}
            />
          }
        />
      ),
    },
    [strings.RAHU_TRANSITS]: {
      [strings.DATA]: (props: any) => (
        <PremiumFeatureWrapper
          setIsLoading={props.setIsLoading}
          component={
            <RahuTransits
              setIsLoading={props.setIsLoading}
              isLoading={props.isLoading}
            />
          }
        />
      ),
    },
    [strings.ARUDHA_PADA]: {
      [strings.DATA]: (props: any) => (
        <PremiumFeatureWrapper
          setIsLoading={props.setIsLoading}
          component={
            <ArudhaPada
              profileId={props.profileId}
              setIsLoading={props.setIsLoading}
            />
          }
        />
      ),
    },
    [strings.SHADBALA]: {
      [strings.DATA]: (props: any) => (
        <PremiumFeatureWrapper
          setIsLoading={props.setIsLoading}
          component={
            <Shadbala
              profileId={props.profileId}
              setIsLoading={props.setIsLoading}
            />
          }
        />
      ),
    },
    [strings.ASPECTS]: {
      [strings.DATA]: (props: any) => (
        <Aspects
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
    },
    [strings.KARMIC_RESOURCES]: {
      [strings.DATA]: (props: any) => (
        <KarmicResourcesCustom
          profileId={props.profileId}
          setIsLoading={props.setIsLoading}
        />
      ),
      //       [strings.PROMPT]: (props: any) => (
      //         <KarmicResources
      //           profileId={props.profileId}
      //           setIsLoading={props.setIsLoading}
      //         />
      //       ),
    },
  };

  const getComponentBasedOnUrl = (
    location: string,
    subTabValue: string,
    selectedLegend?: string,
  ) => {
    const locationComponents = componentMap[location];
    if (!locationComponents) return null;

    const Component = locationComponents[subTabValue];
    if (!Component) return null;

    return Component({
      profileId,
      setIsLoading,
      formFields,
      selectedHouse,
      selectedLegend,
      setDisplayVideo,
      setGoldenFoot,
      isLoading,
    });
  };

  const menuConfig = {
    [strings.ANALYSIS_TAB]: [
      { key: strings.DATA, label: t("data") },
      { key: strings.LEGENDS, label: t("legendsHeader"), type: "dropdown" },
    ],
    [strings.MINERALS_TAB]: [
      { key: strings.DATA, label: t("data") },
      { key: strings.LEGENDS, label: t("legendsHeader") },
    ],
    [strings.MAHADASHA_TAB]: [
      { key: strings.DATA, label: t("data") },
      { key: strings.GOOD_TIME, label: t("goodTime") },
      { key: strings.BAD_TIME, label: t("badTime") },
      { key: strings.CHANGES_IN_ONE_YEAR, label: t("changesInOneYear") },
      { key: strings.CHANGES_IN_LIFE_SPAN, label: t("changesInLifeSpan") },
      { key: strings.LEGENDS, label: t("legendsHeader") },
    ],
    [strings.PLANET_TAB]: [
      { key: strings.DATA, label: t("data") },
      { key: "house", type: "select" },
    ],
    [strings.HOUSES_TAB]: [
      { key: strings.DATA, label: t("data") },
      { key: "house", type: "select" },
    ],
    [strings.FOOTBALL_TAB]: [
      { key: strings.DATA, label: t("data") },
      { key: strings.LEGENDS, label: t("legendsHeader") },
    ],
    [strings.REPORT]: [
      { key: strings.DATA, label: t("data") },
      { key: strings.COMMON_REPORT, label: t("commonReportHeader") },
    ],
    [strings.KARMIC_RESOURCES]: [
      { key: strings.DATA, label: t("data") },
      //       { key: strings.PROMPT, label: t("prompt") },
    ],
    [strings.ASPECTS]: [{ key: strings.DATA, label: t("data") }],
  };

  const getMenuItems = (location: string) => {
    return menuConfig[location] || [{ key: strings.DATA, label: t("data") }];
  };

  const getMainMenu = () => {
    return (
      <>
        <Box sx={classes.menuItemsWrapper}>
          <Stack
            direction={"row"}
            spacing={{ md: 4, xs: 2.5 }}
            pl={{ sm: 5, xs: 0 }}
            pb={1}
            pt={{ md: 0, xs: 1 }}
            justifyContent={"start"}
            sx={classes.menuItems}
          >
            {getMenuItems(location).map((item) => {
              if (item.type === "dropdown") {
                return (
                  <IconButton
                    key={item.key}
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? "account-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    sx={{ p: 0 }}
                  >
                    <Typography
                      sx={
                        selectedSubTab === strings.LEGENDS
                          ? {
                              ...classes.selectedCardLabel,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }
                          : {
                              ...classes.cardLabel,
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                            }
                      }
                    >
                      {item.label}
                      <KeyboardArrowDownIcon sx={{ fontSize: "1.2rem" }} />
                    </Typography>
                  </IconButton>
                );
              }

              if (item.type === "select") {
                return (
                  <CustomSelect
                    key={item.key}
                    menuItems={houseMenu}
                    onChange={handleHouseChange}
                    value={selectedHouse}
                    name={"house"}
                    id={"house"}
                    customClasses={classes.darkTextField}
                  />
                );
              }

              return (
                <Typography
                  key={item.key}
                  sx={
                    selectedSubTab === item.key
                      ? { ...classes.selectedCardLabel, cursor: "pointer" }
                      : { ...classes.cardLabel, cursor: "pointer" }
                  }
                  onClick={() => setSelectedSubTab(item.key)}
                >
                  {item.label}
                </Typography>
              );
            })}
          </Stack>
        </Box>

        <Box sx={classes.scrollStyle}>
          {getComponentBasedOnUrl(location, selectedSubTab, selectedLegend)}
        </Box>
      </>
    );
  };

  const getData = () => {
    return (
      <Box
        sx={
          isTablet ? { ...classes.mainContainer, mt: 1 } : classes.mainContainer
        }
      >
        <Box sx={classes.mainBox}>
          <Box sx={classes.subBox}>{getMainMenu()}</Box>
        </Box>
      </Box>
    );
  };

  const getPageDetails = () => {
    return (
      <>
        {getProfileData()}
        {getData()}
        {getMenu()}
      </>
    );
  };

  const getAnalysis = () => {
    return (
      <Box>
        {getPageDetails()}
        <CustomLoader isLoading={isLoading} />
        <CustomLoader1 isLoading={displayVideo} goldenFoot={goldenFoot} />
      </Box>
    );
  };

  return getAnalysis();
};

export default Analysis;
